module.exports = __webpack_public_path__ + "img/alterar.fb21607f.svg";